import { combineReducers } from 'redux'

import { app } from './app'
import { user } from './user'
import { introducer } from './introducer'
import { formStepper } from './formstepper'
import { userWallets } from './user-wallets'
import { instruments } from './instruments'
import { balances } from './balances'
import { trades } from './trades'
import { fiat } from './fiat'
import { history } from './history'

export const rootReducer = combineReducers({
  app,
  user,
  introducer,
  formStepper,
  userWallets,
  instruments,
  balances,
  trades,
  fiat,
  history,
})
